module.exports = __webpack_public_path__ + "static/img/tow.7f51482.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guoguoImg/tow.png
// module id = XERb
// module chunks = 1